import { InfoCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import React from "react";
import { checkGiftHaveReselect } from "../../shared/helpers";
// import { useTranslation } from "react-i18next";

interface IProductItemGiftsProps {
  quantity: number;
  gifts: any[];
  visible: boolean;
  closeGiftModal: Function;
}

const ProductItemGiftModal = (props: IProductItemGiftsProps) => {
  const { gifts, visible, closeGiftModal, quantity } = props;
  // const { t } = useTranslation();

  const mergeGifts = (gifts: any) =>
    gifts.reduce((r: any, { feature_id, name, note, quantity }: any) => {
      var temp = r.find((o: any) => o.feature_id === feature_id);
      if (!temp) {
        r.push({ feature_id, name, note, quantity });
      } else {
        temp.quantity += quantity;
      }
      return r;
    }, []);

  return Array.isArray(gifts) ? (
    <>
      <Modal
        title={`Danh sách quà tặng khi mua 0${quantity} sản phẩm`}
        visible={visible}
        onCancel={() => closeGiftModal()}
        footer={null}>
        {gifts.length ? (
          <div>
            {mergeGifts(gifts).map((gift: any, index: number) => (
              <div className="gift-item" key={index}>
                <div className="gift-item-content">
                  <p className="gift-item__name">
                    {gift.name.replace("01", "0" + gift.quantity)}
                  </p>
                  <p className="gift-item__feature">{gift.note}</p>
                </div>
              </div>
            ))}
            {checkGiftHaveReselect(gifts) ? (
              <div>
                <span className="sub-content" style={{}}>
                  <InfoCircleOutlined />
                </span>{" "}
                Quý khách có thể chọn màu hoa văn Bộ Ga tặng trong mục giỏ hàng
              </div>
            ) : null}
          </div>
        ) : (
          <p className="gift-item__feature">
            Sản phẩm này hiện không có quà tặng
          </p>
        )}
      </Modal>
    </>
  ) : null;
};

export default ProductItemGiftModal;
